module.exports = __webpack_public_path__ + "img/wenshang.9206d5d3.png";